const domain = /:\/\/([^\\/]+)/.exec(window.location.href)[1]
export default domain.includes(process.env.REACT_APP_PROD_URL)
